import { Link } from 'react-router-dom';
import React from 'react';

const MainMenu = () => {
    return (
        <>
            <ul>
                <li><Link to='/'>Home</Link></li>  
                <li><Link to='/about-us'>About Us</Link></li>
                <li><Link to='/services'>Services</Link></li>
                <li><Link to='/testimonial'>Testimonials</Link></li>
                <li><Link to='/gallery'>Gallery</Link></li>
                <li><Link to='/contact-us'>Contact Us</Link></li>      
            </ul>  
        </>
    );
};

export default MainMenu;